import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import AboutHero from "@/pages/about/components/AboutHero";
import AboutIntroSection from "@/pages/about/components/AboutIntroSection";
import AboutCardsSection from "@/pages/about/components/AboutCardsSection";
import AboutOutroSection from "@/pages/about/components/AboutOutroSection";
import { Link } from "react-router-dom";

export default function AboutEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Sobre nosotros | NetBasis International"
        description="Conozca NetBasis International: su experto sectorial para el apoyo comercial estratégico y operativo desde 2008."
        ogUrl="https://net-basis.net/es/sobre-nosotros"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <AboutHero
          texts={{
            title_line1: "¡Hacemos que las ",
            title_line2: "cosas se muevan ...",
            subtitle: "... para USTED!",
          }}
        />

        <AboutIntroSection
          texts={{
            h1: "Su socio experimentado para el éxito sostenible en el mercado de la región DACH. Bajo el lema \"linking people & business\", acompañamos a los fabricantes extranjeros de TIC desde la planificación estratégica hasta la ejecución operativa exitosa sobre el terreno.",
            p1: "NetBasis International se fundó a principios del año 2008 en Düsseldorf. Desde entonces, bajo el lema \"linking people & business\", ofrecemos a los fabricantes extranjeros del sector de las telecomunicaciones y la informática que desean expandir sus actividades comerciales a los mercados de la región DACH o intensificar sus actividades ya existentes, todo tipo de consultoría y apoyo comercial, así como una asistencia experta en el desarrollo y la adaptación de productos específicos para el mercado.",
            p2: "Junto con nuestros fabricantes socios, respondemos a todas las preguntas estratégicas y trabajamos enfocados en un único objetivo central: ¡su éxito y la obtención de los mejores resultados comerciales en nuevos mercados!",
            p3: "Para alcanzar esta meta, las empresas extranjeras obtienen a través de nosotros un acceso inmediato a conocimientos específicos del sector, a una larga experiencia en el mercado y a una amplia red de contactos. Evitan las barreras culturales y lingüísticas gracias a nuestra presencia inmediata y se benefician de nuestro rápido trabajo operativo en los mercados, productos, socios y clientes.",
            strongName: "NetBasis International",
          }}
        />

        <AboutCardsSection
          texts={{
            management_title: "Dirección",
            management_desc: "Más de 30 años de experiencia: benefíciese de un profundo conocimiento del mercado y de una larga trayectoria directiva internacional para su éxito en la región DACH.",
            core_values_title: "Valores fundamentales",
            core_values_desc: "Valores que inspiran: basados en el respeto, la lealtad y el profesionalismo, aseguramos su éxito en la región DACH – su proyecto está en las mejores manos.",
            mission_vision_title: "Misión/Visión",
            mission_vision_desc: "El factor humano marca la diferencia: la tecnología sola no basta. En estrecha colaboración, llevamos juntos su proyecto hacia un resultado seguro.",
            read_more: "Más información",
          }}
          urls={{
            management: "/es/sobre-nosotros/direccion",
            core_values: "/es/sobre-nosotros/valores-fundamentales",
            mission_vision: "/es/sobre-nosotros/mision-vision",
          }}
        />

        <AboutOutroSection
          texts={{
            strongName: "NetBasis International",
            p4: "Para fortalecer las relaciones existentes, así como para captar nuevos clientes y asegurar un desarrollo más sostenible de los nuevos mercados, apostamos por un enfoque de colaboración en todas las áreas de ventas y marketing. Esto incluye también el trabajo conjunto en soluciones de hardware y software sofisticadas, perfectamente adaptadas a los requisitos actuales del mercado.",
            p5: "Tanto nuestra filosofía empresarial como nuestra orientación ética exigen que NetBasis International se concentre estratégicamente en un número limitado de fabricantes socios competentes que no compitan directamente dentro del sector. Priorizamos deliberadamente el desarrollo conjunto y la cooperación sinérgica dentro del grupo frente a una competencia improductiva.",
            p6: "Todo esto ofrece la máxima seguridad para cada nuevo socio y forma parte integrante del paquete que le ofrecemos cuando decide iniciar una cooperación exitosa con nosotros.",
          }}
        />

        {/* Contact CTA */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              Póngase en contacto con nosotros directamente ahora.
            </h2>
            <Link
              to="/es/contacto"
              className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-4 font-heading text-sm md:text-base font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Formulario de contacto
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}